export const compliance = {
label: 'COMPLIANCE & GOVERNANCE',
title: 'Responsible Processes. Clear Standards.',
subtitle: 'Internal processes designed to support product quality, responsible communications, corporate governance, and market-specific regulatory coordination.',

areas_title: 'Compliance Areas',
area_1: 'Product Quality',
area_1_desc: 'Processes focused on product documentation, quality review, and consistent product information.',
area_2: 'Market-Specific Review',
area_2_desc: 'Product and market requirements are evaluated according to the applicable jurisdiction and intended market.',
area_3: 'Corporate Governance',
area_3_desc: 'Defined internal responsibilities support accountable decision-making and operational discipline.',
area_4: 'Responsible Communications',
area_4_desc: 'Corporate and distributor communications are expected to follow approved product and business information.',

closing_statement: 'Our approach is based on responsible business practices, accurate product information, defined internal responsibilities, and market-specific review. Regulatory requirements may differ by jurisdiction, product category, and intended market.',
};
